module.exports = __webpack_public_path__ + "img/ennetix-applications-page2.dac7842d.png";